"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBox = void 0;
var React = require("react");
require("./index.scss");
var InfoBox = function (props) {
    return (React.createElement("div", { className: 'fields-modal-info-box' },
        React.createElement("p", { className: 'fields-modal-info-box-content' }, props.content)));
};
exports.InfoBox = InfoBox;
